import axios from 'axios';
import config from './config';

const api = axios.create({
  baseURL: config.API,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true // <-- ESSENCIAL para CORS com credenciais
});

export default api;